import { useEffect, useState } from 'react'

import { HelpScreen, type HelpManifest } from '@/screens/HelpScreen'

const manifestUrl = '/help-videos/manifest.json'

export function HelpScreenContainer() {
  const [manifest, setManifest] = useState<HelpManifest | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const [activeVideoId, setActiveVideoId] = useState<string | null>(null)

  useEffect(() => {
    let isMounted = true
    const loadManifest = async () => {
      setIsLoading(true)
      setError(null)
      try {
        const response = await fetch(manifestUrl, { cache: 'no-store' })
        if (!response.ok) {
          throw new Error(`Unable to load help videos (${response.status})`)
        }
        const data = (await response.json()) as HelpManifest
        if (isMounted) {
          setManifest(data)
        }
      } catch (err) {
        if (isMounted) {
          setManifest(null)
          setActiveVideoId(null)
          setError(
            err instanceof Error ? err.message : 'Unable to load help videos',
          )
        }
      } finally {
        if (isMounted) {
          setIsLoading(false)
        }
      }
    }

    loadManifest()
    return () => {
      isMounted = false
    }
  }, [])

  return (
    <HelpScreen
      manifest={manifest}
      isLoading={isLoading}
      error={error}
      activeVideoId={activeVideoId}
      onSelectVideo={(id) => setActiveVideoId(id)}
    />
  )
}
